import { useState, useRef, useEffect } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, ButtonBase, ClickAwayListener, Paper, Popper, useMediaQuery, Typography, Fade } from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';

//  propTypes
import propTypes from 'prop-types';
import { useSelector } from 'react-redux';

// ==============================|| NOTIFICATION ||============================== //

const languageToString = (language) => {
    if (language === 'el') {
        return 'ΕΛ';
    }
    if (language === 'en') {
        return 'EN';
    }
    return '';
};

const Wrapper = ({ children }) => {
    const theme = useTheme();
    const matchesXs = useMediaQuery(theme.breakpoints.down('md'));
    const { language } = useSelector((state) => state.customization);
    const [open, setOpen] = useState(false);
    /**
     * anchorRef is used on different componets and specifying one type leads to other components throwing an error
     * */
    const anchorRef = useRef(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const prevOpen = useRef(open);
    useEffect(() => {
        console.log('open', open);
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);

    useEffect(() => {
        console.log('anchorRef', anchorRef?.current);
    }, [anchorRef]);

    return (
        <>
            <Box
                sx={{
                    ml: 2,
                    mr: 3,
                    [theme.breakpoints.down('md')]: {
                        mr: 2
                    }
                }}
            >
                <ButtonBase sx={{ borderRadius: '12px' }}>
                    <Box
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            textAlign: 'center',
                            transition: 'all .2s ease-in-out',
                            background: theme.palette.secondary.light,
                            color: theme.palette.secondary.dark,
                            '&[aria-controls="menu-list-grow"],&:hover': {
                                background: theme.palette.secondary.dark,
                                color: theme.palette.secondary.light
                            },
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                        ref={anchorRef}
                        aria-controls={open ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        onClick={handleToggle}
                        color="inherit"
                    >
                        <Typography sx={{ fontWeight: 600 }}>{languageToString(language)}</Typography>
                    </Box>
                </ButtonBase>
            </Box>
            <Popper
                placement={matchesXs ? 'bottom' : 'bottom-end'}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
                popperOptions={{
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [matchesXs ? 5 : 0, 20]
                            }
                        }
                    ]
                }}
            >
                {({ TransitionProps }) => {
                    console.log('TransitionProps', TransitionProps);
                    return (
                        // <Transitions position={matchesXs ? 'top' : 'top-right'} {...TransitionProps} in={open}>
                        <Fade {...TransitionProps} timeout={350}>
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                                        {children}
                                    </MainCard>
                                </ClickAwayListener>
                            </Paper>
                        </Fade>
                    );
                }}
            </Popper>
        </>
    );
};

Wrapper.propTypes = {
    children: propTypes.node
};

export default Wrapper;
